import React, { useContext, useEffect, useState } from 'react'
import listApi from '../../services/api';
import { AuthContext } from '../../context/AuthContext';
import { Table } from 'antd';

export default function TransactionManagement() {
    const {userData} = useContext(AuthContext)
    const [listTransaction, setListTransaction] = useState([])

    useEffect(() => {
        fetchListTransaction()
    }, [])
    

    const fetchListTransaction = async () => {
        try {
            const response = await fetch(listApi.listAllTransaction, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    session_id: userData.session_id
                })
            });
            const data = await response.json();
            console.log("Check data order----->", data)
            if (data.code === 200) {
                setListTransaction(data.list_transaction);
            }
        } catch (error) {
            console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
        }
    };

    const columns = [
        {
          title: 'Họ tên',
          dataIndex: ['user_info', 'Fullname'],
          key: 'fullname',
        },
        {
          title: 'Giá',
          dataIndex: 'price',
          key: 'price',
          render: (price) => `${price.toLocaleString()}đ`,
        },
        {
            title: 'Trạng thái',
            dataIndex: ['type_info', 'State'],
            key: 'state',
          },
      
    ]    

    return (
        <div>
          <h2>Quản lý giao dịch</h2>
          <Table columns={columns} dataSource={listTransaction} rowKey="transaction_session" />
        </div>
      );
    
}
